export const teamManagement = {
  forbidden: {
    title: "Dostęp ograniczony",
    desc: "Zespołem może zarządzać wyłącznie główny gospodarz.",
  },
  header: {
    title: "Zarządzanie zespołem",
    subtitle: "Zarządzaj tym, kto ma dostęp do panelu Twojego obiektu",
    addMember: "Dodaj członka",
  },
  stats: {
    totalTeam: "Cały zespół",
    host: "Gospodarz",
    additionalMembers: "Dodatkowi członkowie",
  },
  search: {
    placeholder: "Szukaj po nazwisku lub adresie e-mail…",
  },
  loading: "Wczytywanie zespołu…",
  table: {
    member: "Członek",
    email: "E-mail",
    role: "Rola",
    properties: "Obiekty",
    added: "Dodano",
    actions: "Akcje",
    ownerBadge: "Gospodarz",
    mainHost: "Główny gospodarz",
    viewPermissions: "Zobacz dozwolone funkcje",
    allProperties: "Wszystkie",
    unassigned: "Nieprzypisane",
    notEditable: "Nie do edycji",
    edit: "Edytuj",
    delete: "Usuń",
  },
  surfaces: {
    web: "Web",
    app: "Aplikacja",
  },
  empty: {
    title: "Brak dodatkowych członków",
    desc: "Użyj przycisku <strong>Dodaj członka</strong>, aby zaprosić osoby do swojego zespołu.",
  },
  infoBanner:
    "Członkowie zespołu logują się do panelu własną nazwą użytkownika i hasłem. Każdy profil ma stałe uprawnienia, a dostęp do danych jest weryfikowany po stronie serwera. Właściciel loguje się wyłącznie przez web, a sprzątanie i konserwacja wyłącznie w aplikacji. <strong>Główny gospodarz</strong> zawsze ma pełny dostęp i nie można go usunąć.",
  modal: {
    createTitle: "Dodaj członka",
    editTitle: "Edytuj członka",
    nameLabel: "Imię i nazwisko",
    namePlaceholder: "np. Maria Garcia",
    emailLabel: "Adres e-mail",
    emailPlaceholder: "email@example.com",
    roleLabel: "Profil dostępu",
    viewScope: "Zakres widoku",
    accessIncluded: "Dostęp obejmuje",
    assignedProperties: "Przypisane obiekty",
    selectedCount: "(wybrano {selected} z {total})",
    propertySearchPlaceholder: "Szukaj obiektu…",
    selectAll: "Zaznacz wszystko",
    clear: "Wyczyść",
    noResults: 'Brak wyników dla "{query}"',
    selectAtLeastOneHint: "Wybierz co najmniej jeden obiekt dla tego profilu.",
    noPropertiesWarning:
      "Nie ma obiektów, które można przypisać. Utwórz obiekt przed zapisaniem tego profilu.",
    passwordLabel: "Hasło",
    passwordOptional: "(pozostaw puste, aby nie zmieniać)",
    passwordPlaceholder: "Co najmniej 8 znaków",
    confirmPasswordLabel: "Potwierdź hasło",
    confirmPasswordPlaceholder: "Powtórz hasło",
    showPassword: "Pokaż hasło",
    hidePassword: "Ukryj hasło",
    cancel: "Anuluj",
    create: "Utwórz członka",
    save: "Zapisz zmiany",
  },
  deleteModal: {
    title: "Usuń członka",
    subtitle: "Tej operacji nie można cofnąć",
    confirm:
      "Czy na pewno usunąć z zespołu tę osobę: {name}? Dostęp do panelu zostanie odebrany natychmiast.",
    cancel: "Anuluj",
    delete: "Usuń",
  },
  roleInfo: {
    defaultTitle: "Uprawnienia",
    description:
      "Ten profil jest stały. Jego zakres, sposób dostępu i obiekty są dodatkowo weryfikowane po stronie serwera.",
    understood: "Rozumiem",
  },
  roleDescriptions: {
    anfitrion: "Pełny dostęp do wszystkich obiektów z poziomu web i aplikacji.",
    propietario:
      "Kalendarze i analityka wyłącznie dla przypisanych obiektów. Dostęp przez web.",
    limpieza:
      "Rozpoczynanie sprzątania, zadania i wiadomości dla swoich obiektów. Tylko aplikacja.",
    mantenimiento:
      "Rozpoczynanie konserwacji, zadania i wiadomości dla swoich obiektów. Tylko aplikacja.",
    fallback: "Profil zgodności z ograniczonym dostępem.",
  },
  optionalHints: {
    messages:
      "Podgląd czatów swoich obiektów i odpowiadanie na nie. Po wyłączeniu ta osoba nie zobaczy wiadomości ani nie otrzyma powiadomień o nich.",
  },
  toasts: {
    loadError: "Nie udało się wczytać zespołu.",
    memberAdded: "✓ Członek został dodany do zespołu.",
    memberUpdated: "✓ Dane członka zostały zaktualizowane.",
    saveError: "Nie udało się zapisać. Spróbuj ponownie.",
    memberDeleted: "Członek został usunięty z zespołu.",
    deleteError: "Nie udało się usunąć tego członka.",
  },
};
